import { Component, OnInit } from '@angular/core';
import {commonService} from '../../service/common.service';
import {ForumsService} from '../../service/forums.service'
import { HttpErrorResponse } from '@angular/common/http';
import {Globals } from '../../globals';
import { ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
@Component({
  selector: 'app-forumdetail',
  templateUrl: './forumdetail.component.html',
  styleUrls: ['./forumdetail.component.css'],
  providers:[commonService,ForumsService,Globals]
  
})
export class ForumdetailComponent implements OnInit {
  flist:any;
  msg="";
  postId:any;
  commentbox:any;
  replybox:any;
  forumsList:any;
  isPostLoad=false;

  audiosContainer:any;
  mediaConstraints = { audio: true }
  recorderType:any;
  thisObj:any; 
  audio:any;
  mediaRecorderObj:any;
  mediaRecorder:any;
  ForumDetails={'title':'ForumDetails','desciprtion':'desciprtion'};

  constructor(private commonService:commonService, private forumsService:ForumsService,private global: Globals,private router: Router,private route: ActivatedRoute) { 
    const snapshot:any = router.routerState.snapshot;
    //console.log(snapshot);  // <-- hope it helps
    this.postId={}
    this.commentbox={};
    this.replybox={};

  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
    
      this.postId = params['id'];
      this.getForumDetail();
    });
    
  }

  getForumDetail(){


    var obj={};    
    obj['userId']=this.commonService.user.id;
    obj['id']=this.postId;
    this.forumsService.getforumDetail(obj).subscribe((data:any)=>{
      if(data.error==0){
        this.flist=data.result;
        this.flist.showOption=false;
      }

    },(error:HttpErrorResponse)=>{


    })

  }


  /*=============================== Show Hide Boxes ====================================*/
  showAttachmentBox(postObj){
    postObj.showCommentBox=false;
    if(postObj.showAttachment){
      postObj.showAttachment=false;
    }else{
      postObj.showAttachment=true;
    }

  }
 

  showCommentBox(postObj){
    postObj.showAttachment=false;
    if(postObj.showCommentBox){
      postObj.showCommentBox=false;
    }else{
      postObj.showCommentBox=true;
      if(!postObj.postComments){
        postObj.postComments=[];
      }
      if(postObj.commentCount > postObj.postComments.length && postObj.postComments.length < 5){
        postObj.isCommentLoad=true;
      var obj={};
       obj['userId']=this.commonService.user.id;
        obj['postId']=postObj.id;
        obj['limit']=5;
        obj['offset']=postObj.postComments.length;
      
        this.forumsService.getComments(obj).subscribe((data:any)=>{
         
          if(data.error==0){
            
            Array.prototype.push.apply(postObj.postComments,data.result); 
            //postObj.postComments.concat(data.result);
            //console.log(postObj.postComments);
          }
          postObj.isCommentLoad=false;



        },(error : HttpErrorResponse)=>{ 
          postObj.isCommentLoad=false;     
          this.msg="internal server error!";
        })


      }
    }
  }

  replyTextboxShow(commentdata){
    
    if(commentdata.isShow){
      commentdata.isShow=false;

    }else{

      commentdata.isShow=true;
      
      if(!commentdata.postComments){
        commentdata.postComments=[];
      }
      if(commentdata.commentCount > commentdata.postComments.length && commentdata.postComments.length < 5){
        //console.log("load reply Data");
        commentdata.isCommentLoad=true;
      var obj={};
       obj['userId']=this.commonService.user.id;
       obj['postId']=commentdata.postId;
       obj['pcomment']=commentdata.id;
       obj['limit']=5;
       obj['offset']=commentdata.postComments.length;
      
        this.forumsService.getComments(obj).subscribe((data:any)=>{
         
          if(data.error==0){
            
            Array.prototype.push.apply(commentdata.postComments,data.result); 
            //postObj.postComments.concat(data.result);
            //console.log(commentdata.postComments);
          }
          commentdata.isCommentLoad=false;



        },(error : HttpErrorResponse)=>{ 
          commentdata.isCommentLoad=false;     
          this.msg="internal server error!";
        })


      }




    }

  }
  toggleoption(postObj){       
    if(postObj.showOption){
      postObj.showOption=false;
    }else{
      postObj.showOption=true;
    }
  }

  setPageCount(){
    let obj={}
    obj['postId']=this.postId;
    obj['userId']=this.commonService.user.id;

    this.forumsService.setPageCount(obj).subscribe((data:any)=>{          
        //console.log(data);
        if(data.error==0){
            
        }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })

  }

  ngAfterViewInit() {
   this.setPageCount();
   }




  getImagePath(path,anonymously){
    if(!path || anonymously==1){
      path='avatar.png';
    }
  let res=this.global.profileUrl+path;
  return res;

  }

  datediff(date){
   let date_future:any;
   let date_now:any;

    date_future = new Date();
    date_now = new Date(date);
    let seconds = Math.floor((date_future - (date_now))/1000);
    let minutes = Math.floor(seconds/60);
    let hours = Math.floor(minutes/60);
    let days = Math.floor(hours/24);
    
      hours = hours-(days*24);
      minutes = minutes-(days*24*60)-(hours*60);
      seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
      let res="";
      if(days>30){
        res=date;
      }else if(days){
        res=days+"d ago";
      }else if(hours){

        res=hours+"h ";
        if(minutes){
          res +=minutes+"m ";
        }            
        res +="ago";
      }else if(minutes){
        res =minutes+"m ago";

      }else{
        res ="now";
      }
      return res;

  }
 /*===================================== Comment ==============================*/
 savereply(commentobj,commentValue){
  //console.log(commentValue);
  let objthis=this;
  if(commentValue){
        let commentInsertObj={}
        commentInsertObj['comment']=commentValue;
        commentInsertObj['postId']=commentobj.postId;
        commentInsertObj['userId']=this.commonService.user.id;
        commentInsertObj['pcomment']=commentobj.id;
        this.forumsService.saveComment(commentInsertObj).subscribe((data:any)=>{
          
          if(data.error==0){
            let commentData=data.result;
           
            commentData.user={firstName:this.commonService.user.firstName,lastName:this.commonService.user.lastName,photo:this.commonService.user.photo};
            //console.log(commentData);
            if(!commentobj.postComments){
              commentobj.postComments=[];
            }
           
            if(commentobj.postComments.length<5){
              commentobj.postComments.push(commentData);
            }
            commentobj.commentCount +=1;
            objthis.replybox[commentobj.id]="";
          }


        },(error : HttpErrorResponse)=>{  
          console.log(error);    
            this.msg="internal server error!";
        })

  }       

}

saveComment(postObj,commentValue){
  //console.log(commentValue);
  let objthis=this;
  if(commentValue){
        let commentObj={}
        commentObj['comment']=commentValue;
        commentObj['postId']=postObj.id;
        commentObj['userId']=this.commonService.user.id;
        
        this.forumsService.saveComment(commentObj).subscribe((data:any)=>{
          
          if(data.error==0){
            let commentData=data.result;
           
            commentData.user={firstName:this.commonService.user.firstName,lastName:this.commonService.user.lastName,photo:this.commonService.user.photo};
            //console.log(commentData);
            if(!postObj.postComments){
              postObj.postComments=[];
            }
           
            if(postObj.postComments.length<5){
              postObj.postComments.push(commentData);
            }
            postObj.commentCount +=1;
            objthis.commentbox[postObj.id]="";
          }


        },(error : HttpErrorResponse)=>{  
          //console.log(error);    
            this.msg="internal server error!";
        })

  }        

}

  loadComment(postObj,forcall){

    if(postObj.commentCount > postObj.postComments.length){
      postObj.isCommentLoad=true;
    var obj={};
     obj['userId']=this.commonService.user.id;
    
     obj['limit']=5;
     obj['offset']=postObj.postComments.length;
     if(forcall=='comment'){
      obj['postId']=postObj.id;
     }else if(forcall=='reply'){
      obj['postId']=postObj.postId;
      obj['pcomment']=postObj.id;
     }
    
      this.forumsService.getComments(obj).subscribe((data:any)=>{
       
        if(data.error==0){
          
          Array.prototype.push.apply(postObj.postComments,data.result); 
          //postObj.postComments.concat(data.result);
          //console.log(postObj.postComments);
        }
        postObj.isCommentLoad=false;



      },(error : HttpErrorResponse)=>{ 
        postObj.isCommentLoad=false;     
        this.msg="internal server error!";
      })


    }
  }
    /*=============================== Like =================*/
    postLike(postObj){       
      var obj={};
      obj['userId']=this.commonService.user.id;
      obj['postId']=postObj.id;
      obj['react']=1;     
        if(postObj.mylike){
          
          this.forumsService.deletePostLike(obj).subscribe((data:any)=>{
            postObj.mylike=0;
            postObj.postLikeCount -=1;
          },(error : HttpErrorResponse)=>{              
              this.msg="internal server error!";
          })   
        }else{    

          this.forumsService.savePostLike(obj).subscribe((data:any)=>{
            postObj.mylike=1;
            postObj.postLikeCount +=1;
          },(error : HttpErrorResponse)=>{              
              this.msg="internal server error!";
          })            
        }

    }

    commentLike(commentData){
      var obj={};
      obj['userId']=this.commonService.user.id;
      obj['commentId']=commentData.id;
      obj['react']=1;     
        if(commentData.mylike){            
          this.forumsService.deleteCommentLike(obj).subscribe((data:any)=>{
            commentData.mylike=0;
            commentData.likeCount -=1;
          },(error : HttpErrorResponse)=>{              
              this.msg="internal server error!";
          })              

        }else{          
          

          this.forumsService.saveCommentLike(obj).subscribe((data:any)=>{
            commentData.mylike=1;
            commentData.likeCount +=1;
          },(error : HttpErrorResponse)=>{              
              this.msg="internal server error!";
          })            
        }

    }
    
/*=============================== Bookmark ===================================*/

bookmark(postObj){
var obj={};
obj['postId']=postObj.id;
obj['userId']=this.commonService.user.id;
this.forumsService.bookmark(obj).subscribe((data:any)=>{
if(data.error==0){
  postObj.showOption=false;

}

},(error:HttpErrorResponse)=>{
this.msg="internal server error!";
})


}

isbookmark(postObj){
//console.log("My post Ids");
//console.log(this.Mybookmark.mybookmarkpostId);
//console.log(this.Mybookmark.getbookPostIds());

return false;
}


}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/forumdetail/forumdetail.component.ts